export const adminCategorias = [
  { id: 1, nome: 'Tecnologia da Informação' },
  { id: 2, nome: 'Mobiliário' },
  { id: 3, nome: 'Serviços Gerais' },
  { id: 4, nome: 'Material de Escritório' },
  { id: 5, nome: 'Equipamentos de Segurança' },
  { id: 6, nome: 'Veículos' },
  { id: 7, nome: 'Limpeza e Conservação' },
  { id: 8, nome: 'Engenharia e Obras' },
];

export const adminAtas = [
  {
    id: 1,
    numero: 'ATA-2024-001',
    nome: 'Aquisição de Equipamentos de TI',
    orgao: 'Ministério da Educação',
    uasg: '150001',
    estado: 'DF',
    esfera: 'Federal',
    objeto: 'Aquisição de notebooks e periféricos para atender às demandas das unidades administrativas do Ministério da Educação em todo o território nacional',
    dataInicio: '2024-01-15',
    dataFim: '2024-12-31',
    dataEdital: '2023-11-20',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1],
    anexos: ['edital-ata-001.pdf', 'termo-referencia-ata-001.pdf'],
    pesquisas: 128,
  },
  {
    id: 2,
    numero: 'ATA-2024-002',
    nome: 'Impressoras e Suprimentos TCU',
    orgao: 'Tribunal de Contas da União',
    uasg: '160002',
    estado: 'DF',
    esfera: 'Federal',
    objeto: 'Fornecimento de impressoras e suprimentos para atender às necessidades do Tribunal de Contas da União',
    dataInicio: '2024-02-20',
    dataFim: '2025-02-19',
    dataEdital: '2023-12-10',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1, 4],
    anexos: ['edital-ata-002.pdf'],
    pesquisas: 95,
  },
  {
    id: 3,
    numero: 'ATA-2024-003',
    nome: 'Infraestrutura de Rede CEF',
    orgao: 'Caixa Econômica Federal',
    uasg: '170003',
    estado: 'DF',
    esfera: 'Federal',
    objeto: 'Equipamentos de infraestrutura de rede incluindo switches, roteadores e cabeamento estruturado',
    dataInicio: '2024-03-10',
    dataFim: '2025-03-09',
    dataEdital: '2024-01-05',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1],
    anexos: ['edital-ata-003.pdf', 'especificacoes-tecnicas.pdf'],
    pesquisas: 87,
  },
  {
    id: 4,
    numero: 'ATA-2024-004',
    nome: 'Desktops e Monitores Correios',
    orgao: 'Correios',
    uasg: '180004',
    estado: 'SP',
    esfera: 'Federal',
    objeto: 'Computadores desktop e monitores para modernização do parque tecnológico dos Correios',
    dataInicio: '2024-04-05',
    dataFim: '2025-04-04',
    dataEdital: '2024-02-15',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1],
    anexos: ['edital-ata-004.pdf'],
    pesquisas: 76,
  },
  {
    id: 5,
    numero: 'ATA-2024-005',
    nome: 'Licenciamento Microsoft SEGER-BA',
    orgao: 'SEGER-BA',
    uasg: '190005',
    estado: 'BA',
    esfera: 'Estadual',
    objeto: 'Licenciamento de software Microsoft para todas as secretarias do Estado da Bahia',
    dataInicio: '2024-05-12',
    dataFim: '2025-05-11',
    dataEdital: '2024-03-01',
    status: 'Ativa',
    visibilidade: 'Oculta',
    categorias: [1, 3],
    anexos: ['edital-ata-005.pdf', 'anexo-licenciamento.pdf', 'contrato-padrao.pdf'],
    pesquisas: 64,
  },
  {
    id: 6,
    numero: 'ATA-2023-012',
    nome: 'Nobreaks e Estabilizadores TST',
    orgao: 'TST',
    uasg: '200006',
    estado: 'DF',
    esfera: 'Federal',
    objeto: 'Nobreaks e estabilizadores para garantir a continuidade dos serviços de TI do Tribunal Superior do Trabalho',
    dataInicio: '2023-08-01',
    dataFim: '2024-07-31',
    dataEdital: '2023-06-10',
    status: 'Encerrada',
    visibilidade: 'Visível',
    categorias: [1, 5],
    anexos: ['edital-ata-012.pdf'],
    pesquisas: 112,
  },
  {
    id: 7,
    numero: 'ATA-2024-006',
    nome: 'Servidores e Storages BRB',
    orgao: 'BRB',
    uasg: '210007',
    estado: 'DF',
    esfera: 'Federal',
    objeto: 'Servidores e storages para o data center principal do Banco de Brasília',
    dataInicio: '2024-06-18',
    dataFim: '2025-06-17',
    dataEdital: '2024-04-01',
    status: 'Ativa',
    visibilidade: 'Oculta',
    categorias: [1, 8],
    anexos: ['edital-ata-006.pdf', 'especificacoes-tecnicas-storage.pdf', 'termo-sigilo.pdf'],
    pesquisas: 53,
  },
  {
    id: 8,
    numero: 'ATA-2024-007',
    nome: 'Notebooks Corporativos CREA-BA',
    orgao: 'CREA-BA',
    uasg: '220008',
    estado: 'BA',
    esfera: 'Estadual',
    objeto: 'Notebooks corporativos para os fiscais e engenheiros do CREA-BA em todo o estado',
    dataInicio: '2024-07-01',
    dataFim: '2025-06-30',
    dataEdital: '2024-05-15',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1],
    anexos: ['edital-ata-007.pdf', 'termo-referencia-notebooks.pdf'],
    pesquisas: 41,
  },
  {
    id: 9,
    numero: 'ATA-2024-008',
    nome: 'Mobiliário Escolar PMSP',
    orgao: 'Prefeitura Municipal de São Paulo',
    uasg: '230009',
    estado: 'SP',
    esfera: 'Municipal',
    objeto: 'Aquisição de mobiliário escolar para atender às escolas da rede municipal de ensino de São Paulo',
    dataInicio: '2024-03-01',
    dataFim: '2025-02-28',
    dataEdital: '2024-01-10',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [2],
    anexos: ['edital-ata-008.pdf', 'especificacoes-mobiliario.pdf'],
    pesquisas: 33,
  },
  {
    id: 10,
    numero: 'ATA-2024-009',
    nome: 'Serviços de Limpeza PMC',
    orgao: 'Prefeitura Municipal de Curitiba',
    uasg: '240010',
    estado: 'PR',
    esfera: 'Municipal',
    objeto: 'Contratação de serviços de limpeza e conservação para os prédios públicos da Prefeitura Municipal de Curitiba',
    dataInicio: '2024-04-15',
    dataFim: '2025-04-14',
    dataEdital: '2024-02-20',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [7, 3],
    anexos: ['edital-ata-009.pdf'],
    pesquisas: 27,
  },
  {
    id: 11,
    numero: 'ATA-2024-010',
    nome: 'Frota de Veículos Administrativos SP',
    orgao: 'Secretaria da Fazenda do Estado de São Paulo',
    uasg: '250011',
    estado: 'SP',
    esfera: 'Estadual',
    objeto: 'Aquisição de veículos de passeio e utilitários para renovação da frota administrativa das unidades da Secretaria da Fazenda em todo o Estado de São Paulo',
    dataInicio: '2024-02-01',
    dataFim: '2025-01-31',
    dataEdital: '2023-11-15',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [6],
    anexos: ['edital-ata-010.pdf', 'especificacoes-veiculos.pdf', 'tabela-precos-maximos.pdf'],
    pesquisas: 89,
  },
  {
    id: 12,
    numero: 'ATA-2024-011',
    nome: 'Obras de Infraestrutura Escolar MG',
    orgao: 'Secretaria de Estado de Educação de Minas Gerais',
    uasg: '260012',
    estado: 'MG',
    esfera: 'Estadual',
    objeto: 'Execução de obras de reforma, ampliação e adequação de escolas estaduais em todas as regiões de Minas Gerais, incluindo serviços de engenharia civil, elétrica e hidráulica',
    dataInicio: '2024-05-20',
    dataFim: '2025-11-19',
    dataEdital: '2024-03-10',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [8, 3],
    anexos: ['edital-ata-011.pdf', 'projeto-basico-obras.pdf', 'planilha-orcamentaria.pdf', 'cronograma-fisico.pdf'],
    pesquisas: 156,
  },
  {
    id: 13,
    numero: 'ATA-2024-012',
    nome: 'Equipamentos de Segurança RJ',
    orgao: 'Polícia Civil do Estado do Rio de Janeiro',
    uasg: '270013',
    estado: 'RJ',
    esfera: 'Estadual',
    objeto: 'Aquisição de coletes balísticos, algemas, cassetetes e equipamentos de proteção individual para os agentes da Polícia Civil do Estado do Rio de Janeiro',
    dataInicio: '2024-06-10',
    dataFim: '2025-06-09',
    dataEdital: '2024-04-05',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [5],
    anexos: ['edital-ata-012-rj.pdf', 'especificacoes-tecnicas-epi.pdf', 'certificacoes-exigidas.pdf'],
    pesquisas: 72,
  },
  {
    id: 14,
    numero: 'ATA-2024-013',
    nome: 'Material de Expediente PR',
    orgao: 'Secretaria de Estado da Administração do Paraná',
    uasg: '280014',
    estado: 'PR',
    esfera: 'Estadual',
    objeto: 'Fornecimento de materiais de escritório e expediente para todos os órgãos da administração direta e indireta do Estado do Paraná, incluindo papel A4, canetas, pastas e itens de papelaria em geral',
    dataInicio: '2024-07-01',
    dataFim: '2025-06-30',
    dataEdital: '2024-05-01',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [4],
    anexos: ['edital-ata-013.pdf', 'catalogo-itens-material-expediente.pdf'],
    pesquisas: 118,
  },
  {
    id: 15,
    numero: 'ATA-2024-014',
    nome: 'Serviços de Vigilância Patrimonial PE',
    orgao: 'Secretaria de Defesa Social de Pernambuco',
    uasg: '290015',
    estado: 'PE',
    esfera: 'Estadual',
    objeto: 'Contratação de serviços de vigilância patrimonial armada e desarmada para as unidades prisionais e fóruns do Estado de Pernambuco, com fornecimento de mão de obra e equipamentos',
    dataInicio: '2024-08-15',
    dataFim: '2025-08-14',
    dataEdital: '2024-06-01',
    status: 'Ativa',
    visibilidade: 'Oculta',
    categorias: [5, 3],
    anexos: ['edital-ata-014.pdf', 'termo-referencia-vigilancia.pdf'],
    pesquisas: 44,
  },
  {
    id: 16,
    numero: 'ATA-2024-015',
    nome: 'Limpeza Urbana PCRJ',
    orgao: 'Prefeitura da Cidade do Rio de Janeiro',
    uasg: '300016',
    estado: 'RJ',
    esfera: 'Municipal',
    objeto: 'Serviços de limpeza urbana, coleta de resíduos sólidos e varrição de vias públicas em toda a extensão do município do Rio de Janeiro',
    dataInicio: '2024-01-05',
    dataFim: '2025-01-04',
    dataEdital: '2023-10-20',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [7],
    anexos: ['edital-ata-015.pdf', 'mapa-zoneamento-limpeza.pdf', 'plano-gestao-residuos.pdf'],
    pesquisas: 203,
  },
  {
    id: 17,
    numero: 'ATA-2024-016',
    nome: 'Equipamentos de TI PBH',
    orgao: 'Prefeitura Municipal de Belo Horizonte',
    uasg: '310017',
    estado: 'MG',
    esfera: 'Municipal',
    objeto: 'Aquisição de notebooks, desktops, monitores e periféricos para modernização do parque tecnológico das secretarias municipais de Belo Horizonte',
    dataInicio: '2024-03-15',
    dataFim: '2025-03-14',
    dataEdital: '2024-01-20',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [1],
    anexos: ['edital-ata-016.pdf', 'configuracoes-tecnicas-minimas.pdf'],
    pesquisas: 94,
  },
  {
    id: 18,
    numero: 'ATA-2024-017',
    nome: 'Mobiliário Administrativo PMS',
    orgao: 'Prefeitura Municipal de Salvador',
    uasg: '320018',
    estado: 'BA',
    esfera: 'Municipal',
    objeto: 'Fornecimento de mobiliário administrativo incluindo mesas, cadeiras, armários e estações de trabalho para os prédios da administração municipal de Salvador',
    dataInicio: '2024-09-01',
    dataFim: '2025-08-31',
    dataEdital: '2024-07-10',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [2],
    anexos: ['edital-ata-017.pdf', 'catalogo-mobiliario.pdf'],
    pesquisas: 61,
  },
  {
    id: 19,
    numero: 'ATA-2023-018',
    nome: 'Obras de Drenagem PMPA',
    orgao: 'Prefeitura Municipal de Porto Alegre',
    uasg: '330019',
    estado: 'RS',
    esfera: 'Municipal',
    objeto: 'Execução de obras de drenagem pluvial e contenção de encostas em áreas de risco do município de Porto Alegre, incluindo serviços de terraplanagem e pavimentação',
    dataInicio: '2023-11-01',
    dataFim: '2024-10-31',
    dataEdital: '2023-08-15',
    status: 'Encerrada',
    visibilidade: 'Visível',
    categorias: [8],
    anexos: ['edital-ata-018.pdf', 'estudo-hidrologico.pdf', 'projeto-executivo-obras.pdf'],
    pesquisas: 137,
  },
  {
    id: 20,
    numero: 'ATA-2024-019',
    nome: 'Câmeras de Monitoramento PMF',
    orgao: 'Prefeitura Municipal de Fortaleza',
    uasg: '340020',
    estado: 'CE',
    esfera: 'Municipal',
    objeto: 'Aquisição e instalação de câmeras de videomonitoramento urbano com tecnologia de reconhecimento facial para os principais corredores e praças de Fortaleza',
    dataInicio: '2024-10-01',
    dataFim: '2025-09-30',
    dataEdital: '2024-08-01',
    status: 'Ativa',
    visibilidade: 'Visível',
    categorias: [5, 1],
    anexos: ['edital-ata-019.pdf', 'especificacoes-cameras.pdf', 'mapa-pontos-instalacao.pdf'],
    pesquisas: 48,
  },
];

export const adminProdutoCategorias = [
  { id: 1, nome: 'Notebooks' },
  { id: 2, nome: 'Impressoras' },
  { id: 3, nome: 'Monitores' },
  { id: 4, nome: 'Periféricos' },
  { id: 5, nome: 'Nobreaks' },
  { id: 6, nome: 'Infraestrutura' },
  { id: 7, nome: 'Suprimentos' },
  { id: 8, nome: 'Software' },
];

export const adminWhatsappNumero = '5511988730909';

export const adminProducts = [
  {
    id: 1,
    nome: 'Notebook Dell Inspiron 15',
    sku: 'NB-DELL-001',
    marca: 'Dell',
    categorias: [1],
    estoque: 45,
    vendas: 128,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=%20Dell%20Inspiron%2015%20laptop%20on%20a%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20sharp%20details%20minimalist%20composition&width=800&height=800&seq=prod-dell-inspiron-01&orientation=squarish', principal: true },
      { id: 2, url: 'https://readdy.ai/api/search-image?query=Dell%20Inspiron%20laptop%20angled%20side%20view%20on%20light%20grey%20surface%20professional%20product%20shot%20clean%20background%20high%20resolution&width=800&height=800&seq=prod-dell-inspiron-02&orientation=squarish', principal: false },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: '15.6"', sku: 'NB-DELL-001-PT', estoque: 20, ativo: true },
      { id: 2, cor: 'Prata', tamanho: '15.6"', sku: 'NB-DELL-001-PR', estoque: 15, ativo: true },
      { id: 3, cor: 'Preto', tamanho: '14"', sku: 'NB-DELL-001-PT14', estoque: 10, ativo: true },
    ],
    descricao: '<h3>Notebook Dell Inspiron 15</h3><p>Equipamento ideal para uso corporativo com alto desempenho e confiabilidade.</p><ul><li>Processador Intel Core i7 13ª geração</li><li>16GB RAM DDR5</li><li>SSD 512GB NVMe</li><li>Tela 15.6" Full HD</li><li>Windows 11 Pro</li><li>Garantia de 3 anos on-site</li></ul>',
    atasIds: [1, 8, 17],
    ativo: true,
  },
  {
    id: 2,
    nome: 'Impressora HP LaserJet Pro',
    sku: 'IM-HP-001',
    marca: 'HP',
    categorias: [2],
    estoque: 32,
    vendas: 95,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=HP%20LaserJet%20Pro%20printer%20front%20view%20on%20white%20background%20professional%20product%20photography%20clean%20studio%20lighting%20sharp%20details&width=800&height=800&seq=prod-hp-laserjet-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Branco', tamanho: 'Padrão', sku: 'IM-HP-001-BR', estoque: 32, ativo: true },
    ],
    descricao: '<h3>Impressora HP LaserJet Pro</h3><p>Impressora laser monocromática de alto desempenho para ambientes corporativos.</p><ul><li>Velocidade de impressão: 40 ppm</li><li>Resolução: 1200 x 1200 dpi</li><li>Conectividade: USB, Ethernet, Wi-Fi</li><li>Bandeja de 250 folhas</li><li>Impressão frente e verso automática</li></ul>',
    atasIds: [2],
    ativo: true,
  },
  {
    id: 3,
    nome: 'Monitor LG 24" Full HD',
    sku: 'MN-LG-001',
    marca: 'LG',
    categorias: [3],
    estoque: 67,
    vendas: 87,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=LG%2024%20inch%20Full%20HD%20monitor%20front%20view%20on%20white%20background%20professional%20studio%20product%20photography%20clean%20minimal&width=800&height=800&seq=prod-lg-monitor-01&orientation=squarish', principal: true },
      { id: 2, url: 'https://readdy.ai/api/search-image?query=LG%20monitor%20side%20angle%20view%20showing%20thin%20bezel%20on%20light%20grey%20surface%20professional%20product%20shot&width=800&height=800&seq=prod-lg-monitor-02&orientation=squarish', principal: false },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: '24"', sku: 'MN-LG-001-PT', estoque: 40, ativo: true },
      { id: 2, cor: 'Preto', tamanho: '27"', sku: 'MN-LG-001-PT27', estoque: 27, ativo: true },
    ],
    descricao: '<h3>Monitor LG 24" Full HD</h3><p>Monitor LED IPS de 24 polegadas com excelente qualidade de imagem e design ultrafino.</p><ul><li>Tela IPS 24" Full HD (1920x1080)</li><li>Tempo de resposta: 5ms</li><li>Conexões: HDMI, DisplayPort, VGA</li><li>Tecnologia Flicker Safe</li><li>Ajuste de inclinação</li></ul>',
    atasIds: [4, 17],
    ativo: true,
  },
  {
    id: 4,
    nome: 'Teclado Mecânico Logitech',
    sku: 'PF-LOG-001',
    marca: 'Logitech',
    categorias: [4],
    estoque: 120,
    vendas: 76,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=Logitech%20mechanical%20keyboard%20top%20view%20on%20white%20background%20professional%20product%20photography%20RGB%20lighting%20subtle%20clean%20studio&width=800&height=800&seq=prod-logitech-keyboard-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: 'ABNT2', sku: 'PF-LOG-001-PT', estoque: 80, ativo: true },
      { id: 2, cor: 'Branco', tamanho: 'ABNT2', sku: 'PF-LOG-001-BR', estoque: 40, ativo: false },
    ],
    descricao: '<h3>Teclado Mecânico Logitech</h3><p>Teclado mecânico profissional com switches de alta durabilidade para digitação confortável.</p><ul><li>Switch mecânico Brown (tátil e silencioso)</li><li>Layout ABNT2</li><li>Retroiluminação RGB personalizável</li><li>Estrutura em alumínio</li><li>Conexão USB-C removível</li></ul>',
    atasIds: [1],
    ativo: true,
  },
  {
    id: 5,
    nome: 'Mouse Sem Fio Logitech MX',
    sku: 'PF-LOG-002',
    marca: 'Logitech',
    categorias: [4],
    estoque: 85,
    vendas: 112,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=Logitech%20MX%20wireless%20mouse%20on%20white%20background%20professional%20product%20photography%20ergonomic%20design%20clean%20studio%20lighting&width=800&height=800&seq=prod-logitech-mouse-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Grafite', tamanho: 'Médio', sku: 'PF-LOG-002-GR', estoque: 50, ativo: true },
      { id: 2, cor: 'Grafite', tamanho: 'Grande', sku: 'PF-LOG-002-GRG', estoque: 35, ativo: true },
    ],
    descricao: '<h3>Mouse Sem Fio Logitech MX</h3><p>Mouse ergonômico premium com precisão excepcional para produtividade.</p><ul><li>Sensor Darkfield 4000 DPI</li><li>Conexão Bluetooth e USB Unifying</li><li>Bateria recarregável (até 70 dias)</li><li>Carregamento USB-C</li><li>Compatível com múltiplos dispositivos</li></ul>',
    atasIds: [1, 8, 17],
    ativo: true,
  },
  {
    id: 6,
    nome: 'Nobreak APC 600VA',
    sku: 'NB-APC-001',
    marca: 'APC',
    categorias: [5],
    estoque: 28,
    vendas: 64,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=APC%20UPS%20nobreak%20600VA%20on%20white%20background%20professional%20product%20photography%20clean%20studio&width=800&height=800&seq=prod-apc-nobreak-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: '600VA', sku: 'NB-APC-001-600', estoque: 18, ativo: true },
      { id: 2, cor: 'Preto', tamanho: '1200VA', sku: 'NB-APC-001-1200', estoque: 10, ativo: false },
    ],
    descricao: '<h3>Nobreak APC 600VA</h3><p>Sistema de energia ininterrupta para proteção de equipamentos eletrônicos.</p><ul><li>Potência: 600VA / 330W</li><li>6 tomadas NBR (3 com bateria)</li><li>Proteção contra surtos e oscilações</li><li>Autonomia de até 15 minutos</li><li>Porta USB para gerenciamento</li></ul>',
    atasIds: [6],
    ativo: false,
  },
  {
    id: 7,
    nome: 'Switch Gerenciável 24 Portas',
    sku: 'IF-SW-001',
    marca: 'Cisco',
    categorias: [6],
    estoque: 15,
    vendas: 32,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=Cisco%20managed%20switch%2024%20ports%20on%20white%20background%20professional%20product%20photography%20clean%20studio&width=800&height=800&seq=prod-cisco-switch-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Cinza', tamanho: '24 Portas', sku: 'IF-SW-001-24', estoque: 10, ativo: true },
      { id: 2, cor: 'Cinza', tamanho: '48 Portas', sku: 'IF-SW-001-48', estoque: 5, ativo: true },
    ],
    descricao: '<h3>Switch Gerenciável 24 Portas</h3><p>Switch de alto desempenho para redes corporativas com gerenciamento avançado.</p><ul><li>24 portas Gigabit Ethernet</li><li>4 portas SFP+ 10G uplink</li><li>Gerenciamento via Web, CLI e SNMP</li><li>Suporte a VLANs e QoS</li><li>Empilhamento de até 4 unidades</li></ul>',
    atasIds: [3, 7, 17],
    ativo: true,
  },
  {
    id: 8,
    nome: 'Cabo de Rede CAT6 305m',
    sku: 'IF-CB-001',
    marca: 'Furukawa',
    categorias: [6],
    estoque: 50,
    vendas: 48,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=CAT6%20network%20cable%20roll%20on%20white%20background%20professional%20product%20photography%20clean%20studio&width=800&height=800&seq=prod-cat6-cable-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Azul', tamanho: '305m', sku: 'IF-CB-001-AZ', estoque: 30, ativo: true },
      { id: 2, cor: 'Cinza', tamanho: '305m', sku: 'IF-CB-001-CZ', estoque: 20, ativo: true },
    ],
    descricao: '<h3>Cabo de Rede CAT6 305m</h3><p>Cabo de rede CAT6 de alto desempenho para cabeamento estruturado.</p><ul><li>Categoria 6 U/UTP</li><li>Condutor 23 AWG cobre sólido</li><li>Capacidade de 10 Gigabit</li><li>Banda de 250MHz</li><li>Certificação Anatel</li></ul>',
    atasIds: [3, 17],
    ativo: true,
  },
  {
    id: 9,
    nome: 'Toner HP 85A Preto',
    sku: 'SP-HP-001',
    marca: 'HP',
    categorias: [7],
    estoque: 200,
    vendas: 156,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=HP%2085A%20black%20toner%20cartridge%20on%20white%20background%20professional%20product%20photography%20clean%20studio&width=800&height=800&seq=prod-hp-toner-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: 'Padrão', sku: 'SP-HP-001-PT', estoque: 200, ativo: true },
    ],
    descricao: '<h3>Toner HP 85A Preto</h3><p>Toner original HP para impressoras LaserJet de alto rendimento.</p><ul><li>Rendimento: 1.600 páginas</li><li>Compatível: LaserJet Pro P1102, M1132, M1212nf</li><li>Tecnologia HP Smart</li><li>Instalação rápida e limpa</li><li>Qualidade de impressão profissional</li></ul>',
    atasIds: [2],
    ativo: true,
  },
  {
    id: 10,
    nome: 'Webcam Full HD 1080p',
    sku: 'PF-WC-001',
    marca: 'Logitech',
    categorias: [4],
    estoque: 95,
    vendas: 71,
    fotos: [
      { id: 1, url: 'https://readdy.ai/api/search-image?query=Logitech%20webcam%20Full%20HD%201080p%20on%20white%20background%20professional%20product%20photography%20clean%20studio&width=800&height=800&seq=prod-logitech-webcam-01&orientation=squarish', principal: true },
    ],
    variantes: [
      { id: 1, cor: 'Preto', tamanho: '1080p', sku: 'PF-WC-001-PT', estoque: 60, ativo: true },
      { id: 2, cor: 'Branco', tamanho: '1080p', sku: 'PF-WC-001-BR', estoque: 35, ativo: true },
    ],
    descricao: '<h3>Webcam Full HD 1080p</h3><p>Webcam profissional com qualidade de imagem superior para videoconferências.</p><ul><li>Resolução Full HD 1080p a 30fps</li><li>Campo de visão de 78°</li><li>Microfone integrado com redução de ruído</li><li>Foco automático</li><li>Conexão USB plug-and-play</li></ul>',
    atasIds: [17],
    ativo: true,
  },
];
